import { Component, OnInit } from '@angular/core';
import { announcementService } from '../../../service/announcement.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-uannouncement',
  templateUrl: './uannouncement.component.html',
  styleUrls: ['./uannouncement.component.css'],
  providers:[announcementService]
})
export class UannouncementComponent implements OnInit {
  announcement:any;
  msg="";
  constructor(private announcementobj:announcementService) {


   }

  ngOnInit() {
    this.getannouncement();
  }

  getannouncement(){
    var obj={}
    obj['limit']=3;  
    obj['orderby']="id";
    obj['ordertype']="desc";
    this.announcementobj.getannouncement(obj).subscribe((data:any)=>{
     if(data.error==0){
       //console.log(data);
      this.announcement=data.data;
     }

    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
    });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/uprofile/uannouncement/uannouncement.component.ts